import { MORE_TOOLS_SHEETS, SheetState } from '../sheetTypes';

export const isElementEditorSheet = (sheetState: SheetState): boolean => !!sheetState.config?.containsElementEditor;
export const isNotElementEditorSheet = (sheetState: SheetState): boolean => !isElementEditorSheet(sheetState);
export const isMoreToolsSheet = ({ sheetId }: SheetState): boolean => MORE_TOOLS_SHEETS.includes(sheetId);
